export const shouldLoad = () => !!document.querySelector('.klt-field--textarea textarea[maxlength]');
